import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Menu from '../Menu';
import { useNavigate, useParams } from 'react-router-dom';
import SuccessMessage from '../../components/successMessage';
import FailedMessage from '../../components/FailedMessage';
import Switch from '../../components/Switch';
import useApiUrls from '../../useApiUrls';

const AudioListPackage = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [message, setMessage] = useState("");
  const [playingAudioId, setPlayingAudioId] = useState(null);
  const [audioError, setAudioError] = useState(null);
  const navigate = useNavigate();
  const { getUrlByOperation } = useApiUrls();
  const audioRef = useRef(null);
  const token = getCookie("token");
  const userid = getCookie("userid");

  // Function to fetch audio data
  const fetchCatelogData = async () => {
    const requestBody = {
      id: 0,
      audiopackid: id,
      applycreateddate: false,
      fromcreateddate: 0,
      endcreateddate: 0,
      active: "",
      filename: "",
      filepath: "",
      name: "",
      ispageload: false,
      pagesize: 1000,
      currentpageno: 0,
      withoutpagination: false,
      pagedirection: "first",
    };

    try {
      const AudioSearch = getUrlByOperation("AudioSearch");
      const response = await axios.post('https://api.dqr-display-tms.eventum.co.in/api/AudioPackInfoOperation/Search', requestBody, {
        headers: {
          'X-Authorization': token,
          'UserId': userid,
          'Content-Type': 'application/json-patch+json',
        }
      });

      if (response.data && Array.isArray(response.data.data)) {
      
        setData(response.data.data);
      } else {
        setData([]);
        
      }
    } catch (error) {
      console.error("Error fetching Catalogue data:", error);
    }
  };

  // Fetch data on initial load
  useEffect(() => {
    fetchCatelogData();
  }, [getUrlByOperation, token, userid]);

  const handleAddPop = () => {
    navigate(`/addaudioListPackage/${id}`);
  };

  const handleUpdatePop = (id2) => {
    navigate(`/updateAudioListPackage/${id2}/${id}`);
  };

  const handleDelete = async (e) => {
    if (window.confirm("Are you sure you want to delete this audio pack?")) {
      const requestBody = { id: e.target.id };

      try {
        const AudioDelete = getUrlByOperation("AudioDelete");
        await axios.post('https://api.dqr-display-tms.eventum.co.in/api/AudioPackInfoOperation/Delete', requestBody, {
          headers: {
            'X-Authorization': token,
            'UserId': userid,
            'Content-Type': 'application/json-patch+json',
          }
        });

        setMessage("Data deleted successfully!");
        fetchCatelogData(); // Call search API again to refresh the list

      } catch (error) {
        console.error("Error deleting item:", error);
        setMessage("Failed to delete data");
      }
    }
  };

  const handleToggle = async (e, item) => {
    const apiUrl = item.active ? getUrlByOperation("AudioDeactive") : getUrlByOperation("AudioActive");
    const requestBody = { id: item.id };

    try {
      await axios.post(apiUrl, requestBody, {
        headers: {
          'X-Authorization': token,
          'UserId': userid,
          'Content-Type': 'application/json-patch+json',
        }
      });
      setData(data.map(d => d.id === item.id ? { ...d, active: !item.active } : d));
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [message]);

      const playAudio = (audioItem) => {
    // Reset any previous errors
    setAudioError(null);
    
    // Check if filepath is valid
    if (!audioItem || !audioItem.filepath) {
      console.error("Invalid audio source path", audioItem);
      setAudioError("Invalid audio source path");
      return;
    }

    const audioUrl = audioItem.filepath;
    
    setPlayingAudioId(audioItem.id);
    
    if (audioRef.current) {
      try {
        // First, try to set the source
        audioRef.current.src = audioUrl;
        
        // Then try to load the audio
        audioRef.current.load();
        
        // Finally try to play
        const playPromise = audioRef.current.play();
        
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
            })
            .catch(error => {
              console.error("Error playing audio:", error);
              setAudioError(`Failed to play audio: ${error.message}`);
              setPlayingAudioId(null);
            });
        }
      } catch (error) {
        console.error("Exception in audio playback:", error);
        setAudioError(`Audio playback error: ${error.message}`);
        setPlayingAudioId(null);
      }
    } else {
      console.error("Audio reference is not available");
      setAudioError("Audio player not initialized");
    }
  };

  const pauseAudio = () => {
    setPlayingAudioId(null);
    if (audioRef.current) {
      audioRef.current.pause();
    }
  };

  const handleAudioEnded = () => {
    setPlayingAudioId(null);
  };

  const handleAudioError = (e) => {
    console.error("Audio error:", e);
    // setAudioError("Failed to load audio. Please check the file format and URL.");
    setPlayingAudioId(null);
  };

  return (
    <>
      <Menu />
      <div>
        <div className="wrapper">
          <div className="content-wrapper">
            <section className="content-header">
              <div className="container-fluid">
                <div className="row mb-2">
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <h1 className="mb-0">Audio</h1>
                    <div className="ms-auto">
                      <button
                        type="button"
                        className="btn btn-warning me-2"
                      >
                        Download Zip
                      </button>
                      
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={handleAddPop}
                      >
                        Add Audio
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="content">
              <div className="container-fluid">
                <hr />
                {audioError && (
                  <div className="alert alert-danger" role="alert">
                    {audioError}
                    <button 
                      type="button" 
                      className="close" 
                      onClick={() => setAudioError(null)}
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                )}
                <div className="row">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-header"></div>
                      <div className="card-body table-responsive p-0">
                        <table className="table table-hover text-nowrap">
                          <thead>
                            <tr>
                              <th>Id</th>
                              <th>Name</th>
                              <th>Filename</th>
                              <th>Audio</th>
                              <th>Action</th>
                              <th>Active</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.length > 0 ? (
                              data.map((item, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{item.name || item.name1 || "Unnamed"}</td>
                                  <td>{item.filename}</td>
                                  <td>
                                    {item.filepath ? (
                                      playingAudioId === item.id ? (
                                        <button 
                                          onClick={pauseAudio}
                                          className="btn btn-sm btn-light"
                                        >
                                          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-pause-fill" viewBox="0 0 16 16">
                                            <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5m5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5" />
                                          </svg>
                                        </button>
                                      ) : (
                                        <button 
                                          onClick={() => playAudio(item)}
                                          className="btn btn-sm btn-light"
                                        >
                                          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-play-fill" viewBox="0 0 16 16">
                                            <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393" />
                                          </svg>
                                        </button>
                                      )
                                    ) : (
                                      <span className="text-muted">No audio</span>
                                    )}
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      className="btn btn-success mr-2"
                                      id={item.id}
                                      onClick={() => handleUpdatePop(item.id)}
                                    >
                                      Update
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-danger"
                                      id={item.id}
                                      onClick={handleDelete}
                                    >
                                      Delete
                                    </button>
                                  </td>
                                  <td>
                                    <Switch
                                      isOn={item.active}
                                      handleToggle={(e) => handleToggle(e, item)}
                                      id={item.id}
                                    />
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="6" className="text-center">No audio files found</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>

      <audio
        ref={audioRef}
        controls
        style={{ display: 'none' }}
        onEnded={handleAudioEnded}
        onError={handleAudioError}
      >
        <source src="" type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>

      {message === "Data deleted successfully!" ? (
        <SuccessMessage message={message} />
      ) : (
        ""
      )}

      {message === "Failed to delete data" ? (
        <FailedMessage message={message} />
      ) : (
        ""
      )}
    </>
  );
};

export default AudioListPackage;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}